@if (archive$ | async; as archive) {
  <mat-toolbar>
    @if (!isGuest && (useCompactLayout$ | async) === false) {
      <app-left-sidebar-toggle-button></app-left-sidebar-toggle-button>
    }
    <app-search-result-archive-selector
      [activeArchiveCount]="activeArchiveSearchResultCount()"
    ></app-search-result-archive-selector>
    <button
      mat-icon-button
      [matTooltip]="'REFINE_SEARCH' | transloco"
      matTooltipShowDelay="1000"
      (click)="clickRefineSearch()"
    >
      <mat-icon>find_replace</mat-icon>
    </button>
    <button
      mat-icon-button
      [matTooltip]="'REFRESH' | transloco"
      matTooltipShowDelay="1000"
      (click)="onRefreshSearch()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    @if (!isGuest) {
      <button
        [disabled]="isEditDisabled"
        mat-icon-button
        [matTooltip]="'TOGGLE_EDIT' | transloco"
        matTooltipShowDelay="1000"
        (click)="clickToggleEdit()"
      >
        <mat-icon [class.edit-enabled]="editModeEnabled">edit</mat-icon>
      </button>
    }
    @if (!isGuest) {
      <button
        mat-icon-button
        [disabled]="isNoneSelected"
        [matTooltip]="'ACTIONS' | transloco"
        matTooltipShowDelay="1000"
        (click)="actionMenu.openMenu($event, selectedSearchResults)"
      >
        <mat-icon [matBadge]="selectedCount" [matBadgeHidden]="isNoneSelected"
          >assignment_turned_in</mat-icon
        >
      </button>
    } @else {
      <button
        (click)="onOpenDocuments()"
        mat-icon-button
        [disabled]="isNoneSelected"
      >
        <mat-icon
          [matTooltip]="'OPEN_DOCUMENTS' | transloco"
          matTooltipShowDelay="1000"
          matTooltipPosition="below"
          [matBadge]="selectedCount"
          [matBadgeHidden]="isNoneSelected"
          >file_open</mat-icon
        >
      </button>
    }
    <span class="spacer"></span>
    @if ((useCompactLayout$ | async) === false) {
      @if (!isGuest) {
        <button
          [ngClass]="{
            favorited: $safeNavigationMigration((search$ | async)?.isFavorite),
          }"
          mat-icon-button
          [matTooltip]="'FAVORITE' | transloco"
          matTooltipShowDelay="1000"
          (click)="clickFavorite()"
        >
          <mat-icon>star</mat-icon>
        </button>
      }
      @if (shareLinksSupported) {
        @if (!isGuest) {
          <button
            mat-icon-button
            (click)="clickShare()"
            [matTooltip]="'SHARE' | transloco"
            matTooltipShowDelay="1000"
            matTooltipPosition="below"
            [disabled]="!isSingleSelection"
          >
            <mat-icon>share</mat-icon>
          </button>
        }
      } @else {
        <div
          [matTooltip]="shareLinksUnsupportedMessage"
          matTooltipShowDelay="1000"
        >
          @if (!isGuest) {
            <button
              mat-icon-button
              matTooltipPosition="below"
              [disabled]="true"
            >
              <mat-icon>share</mat-icon>
            </button>
          }
        </div>
      }
      @if (newPdfDocumentsExist$ | async; as newPdfDocumentsExist) {
        <button
          mat-icon-button
          (click)="clickOpenNewDocumentsDialog()"
          [matTooltip]="'OPEN_NEW_DOCUMENTS_DIALOG' | transloco"
        >
          <mat-icon
            [matBadge]="newPdfDocumentCount$ | async"
            [matBadgeHidden]="!newPdfDocumentsExist"
            >tab</mat-icon
          >
        </button>
      }
    } @else {
      @if (!isGuest) {
        <button
          aria-label="More Actions Menu"
          mat-icon-button
          [matMenuTriggerFor]="moreMenu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      <mat-menu #moreMenu="matMenu">
        <button
          mat-menu-item
          [ngClass]="{
            favorited: $safeNavigationMigration((search$ | async)?.isFavorite),
          }"
          (click)="clickFavorite()"
        >
          <mat-icon>star</mat-icon>
          {{ 'FAVORITE' | transloco }}
        </button>
        @if (shareLinksSupported) {
          <button
            mat-menu-item
            (click)="clickShare()"
            [disabled]="!isSingleSelection"
          >
            <mat-icon>share</mat-icon>
            {{ 'SHARE' | transloco }}
          </button>
        } @else {
          <div
            [matTooltip]="shareLinksUnsupportedMessage"
            matTooltipShowDelay="1000"
          >
            @if (!isGuest) {
              <button
                mat-menu-item
                matTooltipPosition="below"
                [disabled]="true"
              >
                <mat-icon>share</mat-icon>
                {{ 'SHARE' | transloco }}
              </button>
            }
          </div>
        }
        @if (newPdfDocumentsExist$ | async; as newPdfDocumentsExist) {
          <button mat-menu-item (click)="clickOpenNewDocumentsDialog()">
            <mat-icon
              [matBadge]="newPdfDocumentCount$ | async"
              [matBadgeHidden]="!newPdfDocumentsExist"
              >tab</mat-icon
            >
            {{ 'OPEN_NEW_DOCUMENTS_DIALOG' | transloco }}
          </button>
        }
      </mat-menu>
    }
    <app-right-sidebar-toggle-button></app-right-sidebar-toggle-button>
  </mat-toolbar>
}
